module.exports = __webpack_public_path__ + "static/media/013.8ccbbcf2.jpg";